import React, { useState } from 'react';
import AfiaChatScreen from './AfiaChatScreen';
import { trackEvent } from '../utils/analytics';

// The launcher on the culture pages. The conversation itself lives in AfiaChatScreen, which
// /afia (the page the event QR code opens) uses too, so both look and behave the same.

const GOLD = '#C9A558';
const INK = '#18100A';

export default function AfiaChatAgent() {
  const [open, setOpen] = useState(false);

  function openChat() {
    setOpen(true);
    trackEvent('afia_chat_open', {});
  }

  function closeChat() {
    setOpen(false);
    trackEvent('afia_chat_close', {});
  }

  return (
    <>
      <style>{`
        @keyframes afiaFabPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(201,165,88,0.55), 0 16px 40px rgba(0,0,0,0.45); }
          50% { box-shadow: 0 0 0 14px rgba(201,165,88,0), 0 20px 48px rgba(154,114,36,0.5); }
        }
        @keyframes afiaFabShine {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }
        .afia-fab:hover { transform: translateY(-3px) scale(1.02); }
        .afia-fab:active { transform: translateY(0) scale(0.98); }
      `}</style>

      <button
        type="button"
        className="afia-fab"
        onClick={openChat}
        aria-label="Chat with Afia"
        style={{
          position: 'fixed',
          right: 'clamp(16px, 3vw, 28px)',
          bottom: 'clamp(16px, 3vw, 28px)',
          zIndex: 960,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 12,
          padding: '8px 20px 8px 8px',
          borderRadius: 999,
          border: '2px solid #fff',
          background: `linear-gradient(120deg, ${GOLD} 0%, #f0d78a 35%, ${GOLD} 70%, #9a7224 100%)`,
          backgroundSize: '200% 200%',
          animation: 'afiaFabPulse 2.4s ease-in-out infinite, afiaFabShine 4s ease infinite',
          color: INK,
          cursor: 'pointer',
          fontFamily: "'Cinzel', serif",
          fontSize: 13,
          fontWeight: 700,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          transition: 'transform 0.2s ease',
        }}
      >
        <span
          style={{
            width: 46,
            height: 46,
            borderRadius: '50%',
            overflow: 'hidden',
            border: `3px solid ${INK}`,
            flexShrink: 0,
            boxShadow: 'inset 0 0 0 2px rgba(255,255,255,0.5)',
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL || ''}/images/afia-hero.webp`}
            alt=""
            style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top' }}
          />
        </span>
        <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1.2 }}>
          <span>Chat with Afia</span>
          <span style={{ fontSize: 9, letterSpacing: '0.2em', opacity: 0.75, fontFamily: "'Montserrat', sans-serif" }}>Ask me anything</span>
        </span>
      </button>

      {open && <AfiaChatScreen onClose={closeChat} />}
    </>
  );
}
